import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./App.css";

import RootComponent from "./root";
const root = createRoot(document.getElementById("root"));
root.render(<RootComponent />);
